import React, { useEffect, useRef, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { Box, Paper, Typography } from "@mui/material";
import { ManageModal, ManageModalProvider, SlideIn, SlideInContextProvider } from "ui";
//ROUTES
import LoginPage from "./UserPages/Login";
import MainMenu from "./components/MainMenu";
import ForgotPassword from "./UserPages/ForgotPassword";
import PasswordReset from "./UserPages/PasswordReset";
import PasswordExpired from "./UserPages/PasswordExpired";
import DashboardRoutes from "./DashboardPages/DashboardRoutes";
import { CompanyRoutes } from "./CompanyPages/CompanyRoutes";
import { LocationRoutes } from "./LocationPages/LocationRoutes";
import { StaffRoutes } from "./StaffPages/StaffRoutes";
import { AnswerRoutes } from "./AnswerPages/AnswerRoutes";

//CONTEXT PROVIDERS
import { CompanyProvider } from "../context/CompanyContext";
import { LocationProvider } from "../context/LocationContext";
import { SessionProvider } from "../context/SessionContext";
import { AnswerProvider } from "../context/AnswerContext";
import { MainMenuContextProvider, useMainMenuContext } from "./components/MainMenu/MainMenuProvider";
import { SelectedPersonProvider } from "../context/StaffContext/StaffProvider";
//STORES
import usePersonStore from "./store/personStore";
import usePersonAuthStore from './store/personAuthStore'
import { GlobalRoutes } from "./GlobalPages/GlobalRoutes";

const RenderRoutes = () => {
    const accessToken = usePersonAuthStore(state => state.access_token)
    const roles = usePersonAuthStore(state => state.roles);
    const hasRun = useRef(false)
    const [notDeveloper, setNotDeveloper] = useState(false)
    const destroyPersonStore = usePersonStore((state) => state.destroy);
    const destroyPersonAuthToken = usePersonAuthStore((state) => state.destroy);
    const setAuthValuesFromAccessToken = usePersonAuthStore(state => state.setAuthValuesFromAccessToken);
    useEffect(() => {
        if (!accessToken || roles.length > 0) {
            return
        }
        setAuthValuesFromAccessToken(accessToken)
    }, [accessToken]);
    useEffect(() => {
        if (hasRun.current || roles.length < 1) return;
        hasRun.current = true;
        if (!roles.includes("DEVELOPER")) {
            setNotDeveloper(true)
        }
    }, [roles])
    if (notDeveloper) {
        destroyPersonAuthToken();
        destroyPersonStore();
        return (
            <Box display="flex" alignItems="center" justifyContent="center" textAlign="center" sx={{ height: '100vh' }}>
                <Box sx={{ width: '500px', }}>
                    <Paper sx={{ padding: 4 }}>
                        <Typography variant="h5" sx={{ marginBottom: 2 }}>Not allowed</Typography>
                        <Typography>This is the futuresthrive Developer Portal. If you are looking for the client portal please visit futuresthrive.health.</Typography>
                    </Paper>
                </Box>
            </Box>
        )
    }
    return <Box component="div" sx={{ backgroundColor: "#F3F6F9", minHeight: "100vh" }}>
        <Router>
            <CompanyProvider>
                <LocationProvider>
                    <AnswerProvider>
                        <SessionProvider>
                            <MainMenuContextProvider>
                                <SelectedPersonProvider>
                                    <SlideInContextProvider>
                                        <ManageModalProvider>
                                            <ManageModal />
                                            <SlideIn />
                                            {AppRoutes()}
                                            {/* <Routes>
                                                <Route path="login" element={<LoginPage />} />
                                                <Route path="forgot-password" element={<ForgotPassword />} />
                                                <Route path="password-expired/:email" element={<PasswordExpired />} />
                                                <Route path="password-reset/:email" element={<PasswordReset />} />
                                                <Route path="answer/*" element={<AnswerRoutes />} />
                                                <Route path="dashboard/*" element={<DashboardRoutes />} />
                                                <Route path="company/*" element={<CompanyRoutes />} />
                                                <Route path="location/*" element={<LocationRoutes />} />
                                                <Route path="staff/*" element={<StaffRoutes />} />
                                                <Route path="global-statistics/*" element={<GlobalRoutes />} />
                                                <Route path="*" element={<Navigate to="/login" replace />} />
                                            </Routes> */}
                                        </ManageModalProvider>
                                    </SlideInContextProvider>
                                </SelectedPersonProvider>
                            </MainMenuContextProvider>
                        </SessionProvider>
                    </AnswerProvider>
                </LocationProvider>
            </CompanyProvider>
        </Router>
    </Box>
}
const AppRoutes = () => {
    const { openMenu } = useMainMenuContext();
    return (
        <>
            <MainMenu />
            <Box sx={{
                width: "100%",
                transition: theme =>
                    theme.transitions.create('margin-left', {
                        duration: theme.transitions.duration.enteringScreen,
                        easing: theme.transitions.easing.easeOut,

                    }),
                marginLeft: openMenu ? "250px" : "0px"
            }}>
                <Routes>
                    <Route path="login" element={<LoginPage />} />
                    <Route path="forgot-password" element={<ForgotPassword />} />
                    <Route path="password-expired/:email" element={<PasswordExpired />} />
                    <Route path="password-reset/:email" element={<PasswordReset />} />
                    <Route path="answer/*" element={<AnswerRoutes />} />
                    <Route path="dashboard/*" element={<DashboardRoutes />} />
                    <Route path="company/*" element={<CompanyRoutes />} />
                    <Route path="location/*" element={<LocationRoutes />} />
                    <Route path="staff/*" element={<StaffRoutes />} />
                    <Route path="global-statistics/*" element={<GlobalRoutes />} />
                    <Route path="*" element={<Navigate to="/login" replace />} />
                </Routes>
            </Box>
        </>
    )
}

export default RenderRoutes